import PrivateLayout from "@/components/layouts/private-layout";
import EditTeacher from "@/pages/teachers/edit-teacher";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/teachers/$teacherId/edit",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PrivateLayout>
      <EditTeacher />
    </PrivateLayout>
  );
}
